// // Use $ instead of jQuery without replacing global $
(function ($) {

  $(document).ready(function () {
    if($('body .col-four-info-slider').length > 0) {
      var $col_four_info_image = $('body .col-four-info-slider .slider-outer .slider .bg-img img');
      objectFitImages($col_four_info_image);
    }
  });

  $(window).on("load", function () {

    $(".col-four-info-slider.ref-slider .slider-outer .slider .item").unwrap();
    $(".col-four-info-slider.ref-slider .slider-outer .slider .item").unwrap();


    $('.col-four-info-slider').each(function () {
      if ($(this).hasClass('reference')) {
      } else {
        $(this).addClass('view');
      }
    });

    setTimeout(function () {
      $('.col-four-info-slider .slider-outer').each(function () {
        $(this).find('.slider').slick({
          arrows: true,
          slidesToShow: 4,
          slidesToScroll: 1,
          fade: false,
          infinite: false,
          draggable: false,
          prevArrow: $(this).parents('.col-four-info-slider').find('.slide-nav .slide-prev'),
          nextArrow: $(this).parents('.col-four-info-slider').find('.slide-nav .slide-next'),
          responsive: [
            {
              breakpoint: 1199,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 576,
              settings: {
                slidesToShow: 1,
                draggable: true
              }
            }
          ]
        });
      });

      $(".col-four-info-slider .slider-outer .slider .item .content h5").matchHeight();
    }, 600);
  });

  $(document).ready(function () {
    // $(".info-slider .slider-outer .slider .item .content h5, .info-slider .slider-outer .slider .item .content h5").matchHeight();
    // limit_lines('body .col-four-info-slider .slider-outer .slider .content h5', 3);

    var has_title = $(".col-four-info-slider h2").length;
    if (has_title == 0) {
      $(".col-four-info-slider").addClass('no-title');
    }

    if ($('.col-four-info-slider').length > 0) {
      // var body_attr1;
      //
      // function resource_link() {
      //   setTimeout(function () {
      //     body_attr1 = $('body').attr('data-region');
      //     $('body .col-four-info-slider .slider-outer').find('.col-four').each(function () {
      //       // console.log(this);
      //       var $data = $(this).attr('data-region');
      //       // console.log($data);
      //       if (body_attr1 === $data || $data === "all") {
      //         $(this).addClass("active");
      //       } else {
      //         $(this).remove();
      //         // console.log(this);
      //       }
      //     });
      //   }, 500);
      // }
      //
      // resource_link();
    }

  });

  $(window).resize(function () {
    // limit_lines('body .col-four-info-slider .slider-outer .slider .content h5', 3);
  });

})(jQuery);